<template>
	<section
		id="memoryWinning--grid"
		class="gif--container"
		:class="{ 'memorygame--multiplayer--container': playersPlaying === 2 }"
	>
		<div class="firework" style="left: 15%; top: 5%"></div>
		<div class="firework"></div>
		<div class="firework"></div>
		<div v-if="playersPlaying === 1" class="winning_img">
			<div
				:class="{
					'memorygame--winning--animation--kids': gameMode === 'kids',
					'memorygame--winning-image': gameMode === 'adults',
				}"
			></div>
		</div>
		<div v-if="playersPlaying === 2">
			<div class="memorygame--losing-image--wrapper">
				<div
					:class="{
						'memorygame--winning--animation--kids--playerone': playerOneWon === true && gameMode === 'kids',
						'memorygame--losing-image--kids--playerone': playerOneWon === false && gameMode === 'kids',
						'memorygame--winning-image--adults--playerone': playerOneWon === true && gameMode === 'adults',
						'memorygame--losing-image--adults--playerone': playerOneWon === false && gameMode === 'adults',
					}"
				></div>
				<div class="score--container">
					<span>Paare:</span>
					<p class="score--text">{{ playerOneScore }}</p>
					<span>Züge:</span>
					<p class="count--text">{{ playerOneFlippedCount }}</p>
				</div>
			</div>
		</div>
		<div v-if="playersPlaying === 2">
			<div class="memorygame--losing-image--wrapper">
				<div
					:class="{
						'memorygame--winning-image--adults--playertwo': playerTwoWon === true && gameMode === 'adults',
						'memorygame--losing-image--adults--playertwo': playerTwoWon === false && gameMode === 'adults',
						'memorygame--winning--animation--kids--playertwo': playerTwoWon === true && gameMode === 'kids',
						'memorygame--losing-image--kids--playertwo': playerTwoWon === false && gameMode === 'kids',
					}"
				></div>
				<div class="score--container--two">
					<span>Paare:</span>
					<p class="score--text--two">{{ playerTwoScore }}</p>
					<span>Züge:</span>
					<p class="count--text--two">{{ playerTwoFlippedCount }}</p>
				</div>
			</div>
		</div>
		<div class="firework"></div>
		<div class="firework"></div>
		<div class="firework"></div>
	</section>
</template>

<script>
import { mapState } from 'vuex';
import { mapStateNested } from '../../tools/helpers';

export default {
	name: 'memoryWinningPage',
	props: {
		playersPlaying: Number,
	},
	computed: {
		...mapState(['gameMode']),
		...mapStateNested('memoryGame', [
			'playerOneFlippedCount',
			'playerTwoFlippedCount',
			'playerOneScore',
			'playerTwoScore',
			'playerOneWon',
			'playerTwoWon',
		]),
	},
};
</script>
